import { useUnpaidBanner } from "components/context/UnpaidBannerContext";
import DigitalSubscriptionUpgradeBanner from "./DigitalSubscriptionUpgradeBanner";
import { SxProps } from "@mui/material";

export default ({ sx }: { sx?: SxProps }) => {
  const { shouldShowDigitalUpgradeBanner, digitalDaysLeft } = useUnpaidBanner();

  if (!shouldShowDigitalUpgradeBanner) {
    return null;
  }

  return (
    <DigitalSubscriptionUpgradeBanner daysLeft={digitalDaysLeft} sx={sx} />
  );
};
